<template>
  <div class="screenshots">
    <div class="title">{{ $tr('responses.tabs.test.screenshots.title') }}</div>
    <div class="screenshots_content" v-if="filteredData.length">
      <div v-for="item in filteredData" class="item">
        <img :src="item.preview" />
      </div>
    </div>
    <div class="buttons" v-if="showMoreButton || showHideButton">
      <div v-if="showMoreButton" class="button">
        <vbutton
          :label="$tr('responses.tabs.test.screenshots.more')"
          @click="count_show += default_count_show"
        />
      </div>
      <div v-if="showHideButton" class="button">
        <vbutton
          :label="$tr('responses.tabs.test.screenshots.hide')"
          @click="count_show = default_count_show"
        />
      </div>
    </div>
    <div v-if="!filteredData.length" class="no-data">
      {{ $tr('responses.tabs.test.screenshots.noData') }}
    </div>
  </div>
</template>
<script>
  export default {
    name: 'bcg-response-tab-test-screenshots-view',
    data() {
      const default_count_show = 9;
      return {
        default_count_show,
        count_show: default_count_show
      };
    },
    props: {
      data: {
        type: Array,
        default: []
      }
    },
    computed: {
      filteredData() {
        return this.data.slice(0, this.count_show);
      },
      showMoreButton() {
        return this.data.length > this.count_show;
      },
      showHideButton() {
        return this.filteredData.length > this.default_count_show;
      }
    }
  };
</script>
<style lang="scss" scoped>
  .screenshots {
    padding: 5px 0;
    border-bottom: 1px solid #d7d7d7;
    .title {
      margin: 10px 0;
      font-size: 16px;
      font-weight: bold;
    }
    .screenshots_content {
      display: flex;
      justify-content: flex-start;
      flex-wrap: wrap;
      margin: 7px 0;
      .item {
        flex-basis: calc(
          calc(100% - 28px) / 3
        ); // 28px - отступ между картинками по 14px
        margin: 7px 14px 7px 0;
        > img {
          width: 100%;
          vertical-align: middle;
        }
        &:nth-of-type(3n) {
          margin-right: 0;
        }
      }
    }

    .buttons {
      display: flex;
      justify-content: flex-start;
      align-items: center;
      flex-wrap: wrap;
      margin: 10px 0;
      .button {
        margin-right: 20px;
        &:last-child {
          margin-right: 0;
        }
      }
    }
    .no-data {
      margin: 10px 0;
      font-size: 15px;
    }
  }
</style>
